import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=323e1e3c&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e1e3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323e1e3c')) {
      api.createRecord('323e1e3c', component.options)
    } else {
      api.reload('323e1e3c', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=323e1e3c&scoped=true&", function () {
      api.rerender('323e1e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2487x3oQa2cym/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports